// extracted by mini-css-extract-plugin
module.exports = {"icon":"_30nii","more":"_3Gmrh","small":"_1JT71","actions":"ya-bx","actionsTop":"_388_9"};